//NOTE - Allows keeping a subset of keys from an object given a whitelist of keys
import JSZip from "jszip";
import { CookingAuxiliarType, CookingProcedureType, getMultilanguageCookingAuxiliarLabel, getMultilanguageCookingProcedureLabel, getMultilanguageNutrientLabels, getNutrientLabel, HomemadeUnits, HomemadeUnitType, NUTRIENT_KEYS, NUTRIENT_UNITS, NutrientKey } from "./constants";
import { omit, pick } from "./utils";
import { convertDishDifficuly, convertDishTypes, convertMealTimes, convertWeekdayToIndex } from "./toFront.converters";




interface ParsedAPIResponse<T = Record<string, any>> {
    success: boolean
    data?: T
    error?: {
        statusCode: number,
        statusText: string,
        body?: Record<string, any>
    }
}


//NOTE -  KEYS contained in a Detailed diet info for any given day
const mealTimeValues = ["AFDS", "AFTS", "BREA", "DINN", "LUNC", "MIDS", "TRAIN"] as const
export type MealTimeType = typeof mealTimeValues[number]

function isMealTimeType(type: string): type is MealTimeType {
    return (mealTimeValues as readonly string[]).includes(type);
}



//NOTE - Inside such keys there are SOME or ALL of the following keys
const dishTypeValues = ["UNIQ", "DESS", "EXTR", "MAIN", "UNIQ", "STAR"] as const
export type DishType = typeof dishTypeValues[number]





// Cosas que necesitan mis peticiones 
// El endpoint
// Un body
// Algo de autenticación






export async function wrappedFetch(

    endpoint: string,
    method: "GET" | "POST" | "PUT",
    requestBody?: Record<string, any>,
    config: {
        useAsFullEndpoint?: boolean,
        headers?: Record<string, string>,
        expect?: "JSON" | "Binary"
    } = {
            useAsFullEndpoint: false,
            headers: {
                "Content-Type": "application/json",

            },
            expect: "JSON"
        }

): Promise<ParsedAPIResponse<any>> {

    const url = !config.useAsFullEndpoint ? `https://backend.munchfit.app${endpoint}` : `${endpoint}`

    const response = await fetch(url,
        {
            headers: (

                config.headers ??
                //By default it will use this
                {
                    "Content-Type": "application/json",
                    // credentials: "include",
                    // Token: sessionStorage.getItem("token"),
                    //  Userid: sessionStorage.getItem("userid"),
                } as any),

            method: method,
            body: JSON.stringify(requestBody)
        })



    // console.log(`SENT ${method} REQUEST to  '${url}'  with body ${JSON.stringify(requestBody)}`)


    if (!response.ok) {
        // Por cómo está hecha la API, no me da mucha info, solo puedo ver el status code 
        // (el body no contiene info sobre qué pasa o por qué)
        return {
            success: false,
            error: {
                statusCode: response.status,
                statusText: response.statusText,
                body: await response.json()
            }
        }
    }


    if (config.expect === "JSON")
        return {
            success: true,
            data: await response.json()
        }

    else
        return {
            success: true,
            data: await response.blob()
        }




}









const basicBodyAuthentication = {
    user_id: sessionStorage.getItem("userid"),
    token: sessionStorage.getItem("token"),
    android_id: 0,
}



export async function requestPlan(plan_id: string): Promise<ParsedAPIResponse> {

    const endpoint = "/getOneDiet"

    const reqBody = {
        ...basicBodyAuthentication,
        diet_id: plan_id
    }
    return wrappedFetch(endpoint,
        "POST", reqBody)
}




//NOTE - Ojo, requiere un array de ids que hace que reciba todos las descripciones de posibilidades para cada momento del día y tal
// returns an array with the description of the independent days.
export async function requestDietDays(diet_day_ids: string[]): Promise<ParsedAPIResponse<Array<Record<string, any>>>> {

    if (!diet_day_ids || diet_day_ids.length === 0)
        throw new Error(`Called requestDietDays with non - nullable parameters `)


    const endpoint = "/getDietDays"
    const reqBody = {
        ...basicBodyAuthentication,
        dietDayIDCollection: diet_day_ids
    }
    return wrappedFetch(endpoint,
        "POST", reqBody)

}




//REVIEW - No funciona ni siquiera para el ejemplo: 67fd1576f9a4a690d3d1fe4d
export async function requestMultipleRecipeDetails(recipe_ids: string[]): Promise<ParsedAPIResponse> {


    if (!recipe_ids)
        throw new Error(`Called requestRecipe with non - nullable parameters `)


    const endpoint = "/getRecipeInstance"
    const reqBody = {
        ...basicBodyAuthentication,
        recipeIDCollection: recipe_ids
    }



    return wrappedFetch(endpoint,
        "POST", reqBody)

}



export async function requestRecipeImageUrls(recipe_ids: string[]): Promise<ParsedAPIResponse> {


    if (!recipe_ids)
        throw new Error(`Called requestRecipeImageUrls with non - nullable parameters `)


    const endpoint = "/getRecipeImages"
    const reqBody = {
        ...basicBodyAuthentication,
        recipes_instances_id: recipe_ids
    }



    return wrappedFetch(endpoint,
        "POST", reqBody,
    )

}



export async function fetchImageItself(url: string): Promise<ParsedAPIResponse> {

    if (!url || url.length === 0) {

        // throw new Error("Can't fetch an image if you don't provide its url")
        return {
            success: false,
            data: undefined,
            error: {
                statusCode: 0,
                statusText: "Frontend error can't fetch an image if you don't provide its url"

            }
        }
    }


    const reqBody = {
        ...basicBodyAuthentication
    }

    return wrappedFetch(url,
        "GET", undefined,
        {
            useAsFullEndpoint: true,
            headers: {
                "credentials": "include",
                "Token": sessionStorage!.getItem("token")!,
                "Userid": sessionStorage!.getItem("userid")!,
            },
            expect: "Binary"
        })

}


export function getAliments() {
    const endpoint = "/getAliments"

    const reqBody = {
        ...basicBodyAuthentication
    }
    return wrappedFetch(endpoint, "POST", reqBody
    )
}




const supportedLanguagesValues = ["es", "fr", "en"] as const
export type SupportedLanguagesKeys = typeof supportedLanguagesValues[number]



//Normalmente llegan los textos como un objeto en cada idioma
export type MultiLanguageObject = Record<SupportedLanguagesKeys, any>





export async function fullPlanDataExtractionForSimulatedMenuInWeb() {




    // 1) Extract the full Diet/Nutrition Plan that holds basically references to plans for specific days of a time period (e.g. a week)
    const { success: successStep1, data: fullNutritionPlan, error: errorStep1 } = await requestPlan("68aeaf35cc9d608b9d563a70");
    if (!successStep1) {
        console.error(`ERROR in step 1): ${JSON.stringify(errorStep1)} `)
        return
    }

    console.log("STEP 1: Full Nutrition plan", fullNutritionPlan)
    //TODO - here  @alreylz
    // fullNutritionPlan?.week_day_start // -> Esto indica precisamente cuál es el día "0" del plan


    //2) Extract array holding the ids of each day (and pass whole array in body of request of further details)
    const dietDaysIdsArray = fullNutritionPlan?.diet_days_ids
    console.log("STEP 2.1 : Obtained diet day ids", dietDaysIdsArray)
    //Fetch each diet day

    // Request detailed plan, with description of all the days. 
    // It returns a 
    const { success: successStep2, data: allDaysArrayDetailedDescription, error: errorStep2 } = await requestDietDays(dietDaysIdsArray)
    if (!successStep2) {
        console.error(`ERROR in step 2): ${JSON.stringify(errorStep2)} `)
        return
    }

    console.log("STEP 2.2 : Detailed Diet Days info", allDaysArrayDetailedDescription)

    const arrayOfSingleDayRecipesCategorized =
        allDaysArrayDetailedDescription?.map((singleDayInfo, index) => {



            const allDayRecipesArray: Array<any> = []

            // Iterating meal Time - whether it is lunch, dinner....
            Object.entries(singleDayInfo).forEach(([mealTimeKey, mtTimeValue]) => {

                if (!isMealTimeType(mealTimeKey))
                    return

                //Iterating dish type: it is MAIN, EXTRA,DESSERT...
                Object.entries(mtTimeValue).forEach(([dishTypeKey, dishTypeValue]) => {
                    //Value is an array with all the differnt dish options
                    if (
                        dishTypeValue &&
                        Array.isArray(dishTypeValue)
                        && dishTypeValue.length > 0) {

                        //Workaround to remove invalid generated data
                        const validDishOptions = dishTypeValue.filter((dishOption) => {
                            return dishOption && dishOption?.calories !== 0
                        })
                        if (validDishOptions.length <= 0)
                            return


                        if (!singleDayInfo.week_day)
                            console.log("found fucking undefined singleDayInfo.week_day", singleDayInfo)


                        for (const dishOption of validDishOptions as any) {
                            //include recipe in the global recipes 
                            allDayRecipesArray.push({
                                day: index, // The day index regardless of what is the first day of the week generated (e.g., first day generated was Thursday)
                                absoluteDayOfWeek: convertWeekdayToIndex(singleDayInfo.week_day),  // Shows an index regarding which day of the week (Monday 0 to Sunday 6)

                                recipeInstanceId: dishOption._id,
                                meal: mealTimeKey,
                                type: dishTypeKey,
                                food_quant: dishOption.food_quant
                            })
                        }

                    }

                })
            }
            )


            return allDayRecipesArray

        }).flat()






    const mapOfSingleDayRecipesCategorized =
        new Map(arrayOfSingleDayRecipesCategorized!.map(r => [r.recipeInstanceId, r]));

    console.log("Step 3.1 Daily Recipes ids:", arrayOfSingleDayRecipesCategorized)


    console.log("Step 3.2. Fetch detail of each recipe instance")


    //REVIEW - This example works
    const listOfAllRecipesId = arrayOfSingleDayRecipesCategorized?.map((recipeBasicsObject) => {
        return recipeBasicsObject?.recipeInstanceId
    })


    const { success: successStep3, data: allDetailedRecipesFetched, error: errorStep3 } = await requestMultipleRecipeDetails(listOfAllRecipesId as Array<string>)

    if (!successStep3) {
        console.error(`ERROR in step 3): ${JSON.stringify(errorStep3)} `)
        return
    }

    console.log("All detailed Recipes", allDetailedRecipesFetched)

    //Combine recipe objects with previous categorization
    const completeDetailRecipesArray = allDetailedRecipesFetched!.map((nuRecipeDetail: any) => {
        const prevDetail = mapOfSingleDayRecipesCategorized.get(nuRecipeDetail._id)

        // console.log(prevDetail)
        // console.log("new", nuRecipeDetail)


        const blacklistOfDetails = ["_id", "hashCode", "creation_timestamp"]

        return {
            ...prevDetail,
            ...omit(nuRecipeDetail, blacklistOfDetails)
        }

    })

    console.log("All full detailed recipes COMBINED with categorization data (as array) - containing also images", completeDetailRecipesArray)


    // TODO - Extraer nombres de los alimentos
    const { success: successFetchAliments, data: alimentsData, error: errorFetchAliments } = await getAliments()

    const alimentsAsMapById =
        new Map(alimentsData!.map((aliment: any) => [aliment._id, aliment]));

    console.log("getAliments", alimentsData)
    const withAlimentsFullList = completeDetailRecipesArray.map((recipe: any) => {


        recipe["ingredients"] = []
        recipe["nutrients"] = []

        //Desglose de alimentos
        // recipe.food_quant // es un array ['f0071:90', 'f0085:60', 'f0240:5', 'f0314:150', 'f0373:60', 'f0416:0']
        for (const alimentQuantity of recipe.food_quant) {

            const [alimentID, quantity] = alimentQuantity.split(":")

            const detailedSingleAlimentData: any = alimentsAsMapById.get(alimentID)


            // detailedSingleAlimentData!.food_name! // Contiene strings para todos los idiomas
            console.log("actual ingredient", detailedSingleAlimentData)
            // from here i am interested in : 
            // - unit_weight: la unidad de medida "normal" (e.g., gramos)
            // - home_measure: el código identificador de la unidad "casera" (i.e., TABL - cucharada)
            // - home_quantity: (normalmente 1, pero indica la proporción de gramos a "1" unidad de lo que sea el home measure)


            //Obtener los textos a usar en cuanto a cantidades (en gramos o en unidades "caseras" - E.g., cucharadas)
            const completeDesgranatedDetailedAlimentData = Object.fromEntries(
                Object.entries(detailedSingleAlimentData!.food_name!).map(([lang, actualIngredientNameInLanguage]) => {


                    //Little helper function to fix the names of the localization keys : nameES -> es
                    const normalizeKeyLang = (keyName: string): SupportedLanguagesKeys => {
                        const lang = keyName.replace("name", "").toLowerCase()

                        if (lang === "es" || lang === "en" || lang === "fr") {
                            return lang;
                        }
                        throw new Error(`Unsupported language or keyName code: ${lang}`);
                    }

                    let abstractUnit: string | "NA" = "NA"
                    let abstractQuantity: number | "NA" = "NA";

                    //NOTE - HERE I am guarding against the fact that some home_quantities are set to -2 meaning (No Aplica)
                    if (
                        !isNA(detailedSingleAlimentData.home_quantity) &&
                        !isNA(detailedSingleAlimentData.net_weight) &&
                        !isNA(detailedSingleAlimentData.home_measure)
                    ) {
                        abstractUnit = HomemadeUnits[detailedSingleAlimentData.home_measure as HomemadeUnitType][normalizeKeyLang(lang)]
                        abstractQuantity = quantity * detailedSingleAlimentData.home_quantity / detailedSingleAlimentData.net_weight
                        abstractQuantity = roundToNearestStep(abstractQuantity, 0.5)
                    }

                    const reformattedActualIngredient =
                    {
                        ingredientName: actualIngredientNameInLanguage, //(e.g., "Queso azul" y sus traducciones)
                        grams: quantity, //quantity in grams or the provided unit
                        abstractUnit: !isNA(abstractUnit) ? abstractUnit : null,
                        abstractQuantity: !isNA(abstractQuantity) ? abstractQuantity : null,

                    }

                    //Convert to proper naming of language
                    return [normalizeKeyLang(lang), reformattedActualIngredient]
                }))
            recipe["ingredients"].push(completeDesgranatedDetailedAlimentData)


            //OJo porque el problema sigue siendo la misma mierda (hay valores especiales - algunas cosas son -2 y otras son 0)
            const nutritionalValuesOfGivenQuantity = Object.fromEntries(
                Object.entries(pick(detailedSingleAlimentData, [...NUTRIENT_KEYS])).map(([nutritionalThing, quantityOfNutritionalValueFromRefValue]) => {
                    //Aquí lo que hago es calcular en base a la cantidad real de producto (en gramos), cuánta cantidad del elemento nutricional hay en todal.
                    //REVIEW - No sé si hay que tener en cuena aquí el net_weight

                    // CANTIDAD REAL DE VALOR NUTRICIONAL dados X gramos de un alimento =  cantidad de alimento *  Proporción de un valor nutricional concreto (e.g., grasa) / valor referencia de proporción
                    let overallNutritionalValueGivenGramsOfSingleFood =
                        quantity / 100.0 * quantityOfNutritionalValueFromRefValue
                    // / (!isNA(detailedSingleAlimentData.net_weight) ? detailedSingleAlimentData.net_weight : 1.0)
                    overallNutritionalValueGivenGramsOfSingleFood = clamp(overallNutritionalValueGivenGramsOfSingleFood, 0)

                    return [nutritionalThing, overallNutritionalValueGivenGramsOfSingleFood]
                }))
            recipe["nutrients"].push(nutritionalValuesOfGivenQuantity)
            // console.log("nutritional Values of given quantity", nutritionalValuesOfGivenQuantity)
        }

        // Obtener overall recipe nutrients
        recipe["overallNutrients"] = combineNutrients(recipe["nutrients"], NUTRIENT_UNITS)


        return recipe


    })



    console.log("withAlimentsFullList ", withAlimentsFullList)
    //Here transform recipes array



    //Final touches for each recipe
    const finalRecipesList = withAlimentsFullList.map((recipe: any) => {


        // const cleanedUpRecipe = 

        // a eliminar
        // - id_master_recipe
        // - mean_foods
        // - food_quant
        // - portable
        // - preparation

        return {
            // ...recipe,
            ["id"]: recipe.id_master_recipe,
            ["name"]:  Object.fromEntries(Object.entries(recipe.recipe_name).map(([lang, name]) => { return [lang.toLowerCase(), name] })),
            ["pictureUrl"]: recipe.urlimg ? `${recipe.urlimg?.slice(0, (recipe.urlimg?.lastIndexOf("_")))}.webp` : undefined,
            ["time"]: `${recipe.cook_time} min`,
            ["instanceId"]: recipe.recipeInstanceId,
            ["difficulty"]: convertDishDifficuly(recipe.difficulty),
            ["meal"]: convertMealTimes(recipe.meal),
            ["day"]: recipe.day,
            ["weekday"]: recipe.absoluteDayOfWeek,
            ["type"]: convertDishTypes(recipe.type),
            ["steps"]: Object.fromEntries(Object.entries(recipe.preparation).map(([lang, val]) => { return [lang.toLowerCase(), (val as string).split(".").filter((val) => val !== "")] })),
            ["ingredients"]: recipe.ingredients,
            ["nutritionalData"]: recipe.overallNutrients,
            ["cook_type"]: recipe.cook_type.map((item: string) => { return { item: item, label: getMultilanguageCookingProcedureLabel(item as CookingProcedureType) } }),
            ["cook_aux"]: recipe.cook_aux.map((item: string) => { return { item: item, label: getMultilanguageCookingAuxiliarLabel(item as CookingAuxiliarType) } })
        }
    })


    // 

    console.log("finalRecipes ", finalRecipesList)

    const search = "6805e642f9a4a690d3016b6d"

    console.log("THE TEST RECIPE", finalRecipesList.filter((recipe: any) => recipe.instanceId === search)[0])


    // NOTE - Pending here extracting and downloading the pictures (maybe)    


    // avoiding the execution of image downloading

    // console.log("IMAGE URLs", await requestRecipeImageUrls(listOfAllRecipesId as string[]))
    const { success: successStep4, data: dictionaryOfImageUrls, error: errorStep4 } = await requestRecipeImageUrls(listOfAllRecipesId as string[])

    if (!successStep4) {
        console.error(`ERROR in step 4): ${JSON.stringify(errorStep4)} `)
        return
    }

    console.log("ALL IMAGE URLS", dictionaryOfImageUrls)

    if (!dictionaryOfImageUrls) {
        console.error("Image URLS is empty (see dictionaryOfImageUrls) ")
        return

    }


    const extraDetailsDictionaryOFImageUrls =
        Object.entries(dictionaryOfImageUrls!).
            reduce((acc: any, [recipeId, details]) => {


                const fullUrl: string | undefined = details?.["256"]
                if (!fullUrl) return acc

                let nameFromUrlNoSizeSuffix = fullUrl?.split("/").pop()?.split(".")?.[0] ?? undefined

                // const size = nameFromUrlNoSizeSuffix!.slice(nameFromUrlNoSizeSuffix?.lastIndexOf("_"))
                nameFromUrlNoSizeSuffix = nameFromUrlNoSizeSuffix!.slice(0, (nameFromUrlNoSizeSuffix?.lastIndexOf("_")))



                acc[`${recipeId}`] = {
                    ...details,
                    "filename": nameFromUrlNoSizeSuffix,
                    "extension": fullUrl?.split(".")?.pop()
                }

                return acc

            }, {} as Record<string, any>)


    return extraDetailsDictionaryOFImageUrls



}










export function downloadAllImages(
    imageProps: Array<{
        filename: string,
        extension: string,
        objectURLSmall: string
    }>
) {


    imageProps.forEach((prepImageData) => {

        console.log("image prep", prepImageData)
        const a = document.createElement("a");
        a.href = prepImageData.objectURLSmall;
        a.download = `${prepImageData.filename}.${prepImageData.extension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

    });
}







const ZIP_DEFAULT_OPTIONS = Object.freeze(
    {
        zipFileName: "allImages",
    }
)



export async function downloadAllImagesAsZip(
    imageProps: Array<{
        filename: string;
        extension: string;
        blobImageSmall: Blob;
        blobImageBig: Blob
    }>,
    zipOptions?: {
        zipFileName: string

    }
) {

    //SET DEFAULTS IF NOT PROVIDED
    if (!zipOptions)
        zipOptions = ZIP_DEFAULT_OPTIONS


    const zip = new JSZip();


    //For each image to be zipped
    for (const prepImageData of imageProps) {
        console.log("Adding image to zip:", prepImageData);
        //Create a folder
        const folderSmallImages = zip.folder("256")
        const folderBigImages = zip.folder("1024")

        if (!folderSmallImages || !folderBigImages)
            throw new Error("Problem creating folder")
        //I already have created the objectURL before
        //just add the file to the folder
        folderSmallImages.file(`${prepImageData.filename}_${"256"}.${prepImageData.extension}`, prepImageData.blobImageSmall);
        folderBigImages.file(`${prepImageData.filename}_${"1024"}.${prepImageData.extension}`, prepImageData.blobImageBig);
    }

    // Generate the zip full zip as a blob
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Create a temporary <a> to download the ZIP
    const link = document.createElement("a");
    const zipUrl = URL.createObjectURL(zipBlob);

    link.href = zipUrl;
    link.download = `${zipOptions.zipFileName}.zip`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the object URL
    URL.revokeObjectURL(zipUrl);
}





// In the backend, not applicable is encoded in the different fields using -2 but the usage is quite inconsistent,
// so this checks both the string and the number version
function isNA(value: string | number) {
    if (typeof value === "number") {
        return value === -2;
    }
    if (typeof value === "string") {
        return value === "-2" || value === "-2.0";
    }
    return false;
}



function roundToNearestStep(num: number, step = 0.5) {
    return Math.round(num / step) * step;
}





function clamp(value: number, min: number, max: number = Number.POSITIVE_INFINITY): number {
    return Math.min(Math.max(value, min), max);
}



interface NutrientDisplay {
    label: MultiLanguageObject;
    value: number;
    unit: string;
}

function combineNutrients(nutrientsArray: Record<string, number>[], units: Record<string, string>): Record<string, NutrientDisplay> {
    const result: Record<string, NutrientDisplay> = {};


    for (const nutrientKey of Object.keys(units)) {
        let total = 0;
        for (const foodNutrients of nutrientsArray) {
            total += foodNutrients[nutrientKey] || 0;
        }
        // Clamp and round to 2 decimals
        total = Math.max(0, Math.round(total * 100) / 100);

        const multilanguageNutriendLabel = getMultilanguageNutrientLabels(nutrientKey as NutrientKey)

        result[nutrientKey] = {
            label: multilanguageNutriendLabel,
            value: total,
            unit: units[nutrientKey]
        };
    }

    return result;
}